    <div class="container">
        <div class="row mb-4 mt-4">
            <div class="col-12 mb-3 mb-lg-5">
                <a [routerLink]="['/','admin', 'tours-update', idViaje]" class="mb-4 d-flex flex-row align-items-center text-decoration-none">
                    <img src="../assets/images/body/icons/volver.svg" class="pe-2" alt="">
                    <h4 class="text-primary mb-0"> Volver</h4>
                </a>
            </div>
            
            <div class="col-lg-8 col-xxl-8 col-4 z-index--top">
                <h3 class="mb-2">Excursiones</h3>  
            </div>
            <div class="col-lg-4 col-xxl-4 col-8 z-index--top d-flex justify-content-md-end justify-content-center">
                 
            </div>
            
        </div>
        
        <div class="row">
            <form [formGroup]="form" class="login">
                <div formArrayName="excursiones">
                    <div [formGroupName]="i" *ngFor="let excursion of excursiones.controls; let i = index;">
                        <div class="row">
                            <div class="col-12 col-md-8">
                                <div class="row mb-5 bg-grey br-30-10 py-4 px-4 shadow-sm">
                                    <div class="col-12 mb-4">
                                        <h3 class="text-secondary">Título</h3>
                                        <div class="pt-2">
                                            <input type="text" formControlName="titulo" class="w-100">
                                        </div> 
                                        <div *ngIf="submitted && form.controls['excursiones'].controls[i].controls['titulo'].errors" class="text-danger">
                                            <div *ngIf="form.controls['excursiones'].controls[i].controls['titulo'].errors.required">Título es requerido.</div>
                                        </div>       
                                    </div>           
                                    <div class="col-12 mb-4">
                                        <h3 class="text-secondary">Descripción</h3>
                                        <div class="pt-2">
                                            <textarea type="text" formControlName="descripcion" class="w-100"></textarea>
                                        </div> 
                                        <div *ngIf="submitted && form.controls['excursiones'].controls[i].controls['descripcion'].errors" class="text-danger">
                                            <div *ngIf="form.controls['excursiones'].controls[i].controls['descripcion'].errors.required">Descripción es requerida.</div>
                                        </div>               
                                    </div> 
                                    <div class="row">
                                        <div class="col-12 col-md-12 text-end">
                                            <button style="cursor: pointer;"  type="button" (click)="deleteExcursion(i)" class="lh-1 btn btn-lg btn-primary rounded-pill text-center btn-reservar align-self-center mt-lg-0 mt-4">Eliminar excursión <img style="height: 30px; width: 30px;" src="../assets/images/body/icons/minus.svg" class="ps-2" alt=""></button>
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                            <div class="col-md-4 col-12 position-relative">
                                <input type="file" [id]="i" name="imagen" style="display:none"
                                    accept="image/jpeg, image/jpg, image/png" (change)="fileEvent($event, i)"/>
                                    <div *ngIf="form.controls['excursiones'].controls[i].controls['imagen'].value===''">
                                        <img src="../assets/images/body/tours/excursion1.jpg" class="img-fluid radius-10" alt="">
                                    </div>
                                    <div *ngIf="form.controls['excursiones'].controls[i].controls['imagen'].value.ext!==''">
                                        <img [src]="form.controls['excursiones'].controls[i].controls['imagen'].value.localUrl" class="img-fluid radius-10" alt="">
                                    </div> 
                                    <div *ngIf="submitted && form.controls['excursiones'].controls[i].controls['imagen'].errors" class="text-danger">
                                        <div *ngIf="form.controls['excursiones'].controls[i].controls['imagen'].errors.required">Imagen es requerida.</div>
                                    </div>   
                                    <div *ngIf="form.controls['excursiones'].controls[i].controls['imagen'].value.toBig" class="text-danger">
                                        <div>La imagen excede los 2MB</div>
                                    </div>                                  
                                <label [for]="i" class="btn btn-md btn-primary rounded-pill text-center btn-reservar position-absolute cargar-imagen">Cargar Imagen <img src="../assets/images/body/icons/edit.svg" alt=""></label>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-12 col-md-12 text-end mt-3">
            <button style="cursor: pointer;"  type="button" (click)="addExcursion()" class="lh-1 btn btn-lg btn-primary rounded-pill text-center btn-reservar align-self-center mt-lg-0 mt-4">Agregar excursiones <img style="height: 30px; width: 30px;" src="../assets/images/body/icons/plus.svg" class="ps-2" alt=""></button> 
        </div>
        <hr class="mb-5">

    </div>
    <div class="col-12 text-center z-index--top">
        <button style="cursor: pointer;"  type="button" (click)="salvar()" class="btn btn-lg rounded-pill btn-primary text-white text-center align-self-center z-index--top ">Guardar Cambios</button> 
    </div>
